export const initShowHideToggles = () => {
    const showToggles = document.querySelectorAll('.show-toggle');
    showToggles.forEach((toggle) => {
        if (!('target' in toggle.dataset)) {
            return;
        }
        const target = document.querySelector(toggle.dataset.target);
        if (target instanceof HTMLElement) {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                target.classList.toggle('shown');
                target.scrollIntoView({
                    behavior: 'smooth',
                });
            });
        }
    });
};
